
import { defineComponent, ref, reactive, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage } from "element-plus"
import { Loading } from "@element-plus/icons-vue"
import { RunGiftRecord } from "@/store/modules/RunGiftRecordModule"
import ApiService from "@/core/services/ApiService"

interface BoxInfoOption {
  id: number;
  name: string;
}

interface ExpandState {
  ranking: any;
  error: string | null;
}

export default defineComponent({
  components: { Loading },
  setup() {
    const store = useStore()
    const tableRef = ref()

    onMounted(() => {
      setCurrentPageBreadcrumbs("冲冲赏记录", ["抽赏中心"])
      loadBoxInfos()
    })

    const tableData = ref<RunGiftRecord[]>([])
    const boxInfoOptions = ref<BoxInfoOption[]>([])
    const expandData = reactive<Record<number, ExpandState>>({})

    // 获奖排名弹窗
    const winnerDialogVisible = ref(false)
    const winnerLoading = ref(false)
    const winnerData = ref<any>(null)

    const formData = ref({
      box_info_id: null as number | null,
      mobile: '',
      from: '',
      to: ''
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    })

    const loadBoxInfos = async () => {
      try {
        await store.dispatch(Actions.GET_BOX_INFOS, { currentPage: 1, pageSize: 9999 })
        const list = store.getters.currentBoxInfos || []
        boxInfoOptions.value = list.map((b: any) => ({
          id: b.id,
          name: b.name
        }))
      } catch (error) {
        console.error('加载套系列表失败', error)
      }
    }

    const loadRanking = ({ row }: { row: any }) => {
      return new Promise<void>((resolve) => {
        ApiService.setHeader()
        ApiService.get(`admin/run_gift_records/${row.id}/ranking`)
          .then(({ data }) => {
            if (data.success) {
              expandData[row.id] = { ranking: data.data, error: null }
            } else {
              expandData[row.id] = { ranking: null, error: data.message || '加载排名失败' }
            }
            resolve()
          })
          .catch(() => {
            expandData[row.id] = { ranking: null, error: '加载排名失败' }
            resolve()
          })
      })
    }

    const onWinnerRanking = () => {
      if (!formData.value.from || !formData.value.to) {
        ElMessage.warning('请先选择日期区间')
        return
      }
      winnerDialogVisible.value = true
      winnerLoading.value = true
      winnerData.value = null

      ApiService.setHeader()
      ApiService.get("admin/run_gift_records/winner_ranking", `?from=${formData.value.from}&to=${formData.value.to}`)
        .then(({ data }) => {
          winnerLoading.value = false
          if (data.success) {
            winnerData.value = data.data
          } else {
            ElMessage.error(data.message || '获取排名失败')
          }
        })
        .catch(() => {
          winnerLoading.value = false
          ElMessage.error('获取排名失败')
        })
    }

    const query = () => {
      const params: Record<string, unknown> = {
        ...page.value
      }
      if (formData.value.box_info_id) {
        params.box_info_id = formData.value.box_info_id
      }
      if (formData.value.mobile) {
        params.mobile = formData.value.mobile
      }
      if (formData.value.from) {
        params.from = formData.value.from
      }
      if (formData.value.to) {
        params.to = formData.value.to
      }

      store
        .dispatch(Actions.GET_RUN_GIFT_RECORDS, params)
        .then(() => {
          tableData.value = store.getters.currentRunGiftRecordsList
          page.value.totalResult = store.getters.currentRunGiftRecordsCount
        })
        .catch(() => {
          ElMessage.error('获取冲冲赏记录失败')
        })
    }

    query()

    const submitEvent = () => {
      page.value.currentPage = 1
      query()
    }

    const onPageChange = (e: { currentPage: number; pageSize: number }) => {
      page.value.currentPage = e.currentPage
      page.value.pageSize = e.pageSize
      query()
    }

    const onReset = () => {
      formData.value = {
        box_info_id: null,
        mobile: '',
        from: '',
        to: ''
      }
      page.value.currentPage = 1
      query()
    }

    return {
      tableRef,
      tableData,
      formData,
      boxInfoOptions,
      expandData,
      page,
      submitEvent,
      onPageChange,
      onReset,
      loadRanking,
      winnerDialogVisible,
      winnerLoading,
      winnerData,
      onWinnerRanking
    }
  },
})
